import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSonnerToaster } from 'ngx-sonner';
import { TranslationService } from './shared/i18n';
import { English } from './shared/i18n/vocabs/en';
import { Russian } from './shared/i18n/vocabs/ru';
import { ThemeService } from './shared/services/theme.service';

@Component({
  selector: 'body[root]',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, NgxSonnerToaster],
  standalone: true,
})
export class AppComponent implements OnInit {
  private readonly translationService = inject(TranslationService);
  private readonly themeService = inject(ThemeService);

  ngOnInit() {
    this.translationService.loadTranslations(English, Russian);
    this.themeService.initTheme();
  }
}
